import { useNavigate } from "react-router-dom";
import {
    FaSignOutAlt,
    FaTrashAlt,
    FaExclamationTriangle,
} from "react-icons/fa";

import "./CustomerDangerZone.css";

function CustomerDangerZone() {

    const navigate = useNavigate();

    const logout = () => {

        const ok = window.confirm(

            "Are you sure you want to logout?"

        );

        if(!ok) return;

        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("role");
        localStorage.removeItem("mode");

        navigate("/login");

    };

    const deleteAccount = () => {

        const ok = window.confirm(

            "Delete your HomeFoods account permanently?\n\nThis action cannot be undone."

        );

        if(!ok) return;

        alert(
            "Backend Delete Account API will be connected here."
        );

    };

    return (

        <div className="danger-page">

            <div className="danger-header">

                <FaExclamationTriangle />

                <div>

                    <h2>

                        Danger Zone

                    </h2>

                    <p>

                        Sensitive account actions.

                    </p>

                </div>

            </div>

            <div className="danger-card">

                <button

                    className="logout-button"

                    onClick={logout}

                >

                    <FaSignOutAlt />

                    Logout

                </button>

                <button

                    className="delete-button"

                    onClick={deleteAccount}

                >

                    <FaTrashAlt />

                    Delete Account

                </button>

            </div>

            <div className="warning-card">

                <h3>

                    Before deleting your account

                </h3>

                <ul>

                    <li>

                        All saved addresses will be removed.

                    </li>

                    <li>

                        Order history cannot be recovered.

                    </li>

                    <li>

                        Reward points will be lost.

                    </li>

                    <li>

                        Wallet balance (future feature) will be forfeited.

                    </li>

                </ul>

            </div>

        </div>

    );

}

export default CustomerDangerZone;